import { API_BASE } from "@/lib/api";

async function downloadExport(path, fallbackName) {
  const token = localStorage.getItem("mt5_token");
  const res = await fetch(`${API_BASE}${path}`, {
    credentials: "include",
    headers: token ? { Authorization: `Bearer ${token}` } : {},
  });
  if (!res.ok) throw new Error("Export failed");
  const blob = await res.blob();
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = res.headers.get("Content-Disposition")?.match(/filename="(.+)"/)?.[1] || fallbackName;
  a.click();
  URL.revokeObjectURL(url);
}

/** Today's snapshot — all accounts, opening/closing balance, max DD. */
export function downloadAccountsCsv() {
  return downloadExport("/reports/export/csv?scope=today", "mt5hub-accounts.csv");
}

/** Full daily session history per account. */
export function downloadHistoryCsv() {
  return downloadExport("/reports/export/csv?scope=history", "mt5hub-sessions-history.csv");
}
